import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2Icon } from 'lucide-react';
export function ValueAnchorSection() {
  return <section className="py-12 bg-background-dark" data-id="element-391">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-392">
        <FadeIn data-id="element-393">
          <div className="bg-[#1A1A1A] border-2 border-primary rounded-3xl p-8 md:p-12 text-center shadow-[0_0_30px_rgba(217,95,2,0.15)]" data-id="element-394">
            <h2 className="text-2xl md:text-4xl font-black text-primary font-heading uppercase tracking-wider mb-8" data-id="element-395">
              LO QUE RECIBÍS HOY
            </h2>

            <div className="space-y-4 mb-10 text-left max-w-xl mx-auto" data-id="element-396">
              <div className="flex items-center gap-3" data-id="element-397">
                <CheckCircle2Icon className="w-6 h-6 text-success shrink-0" data-id="element-398" />
                <span className="text-white font-bold text-lg" data-id="element-399">
                  Pack Bases del Entrenamiento de Fuerza
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-400">
                <CheckCircle2Icon className="w-6 h-6 text-success shrink-0" data-id="element-401" />
                <span className="text-white font-bold text-lg" data-id="element-402">
                  Bono 1: Bases Nutricionales del Desarrollo Muscular
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-403">
                <CheckCircle2Icon className="w-6 h-6 text-success shrink-0" data-id="element-404" />
                <span className="text-white font-bold text-lg" data-id="element-405">
                  Bono 2: La Práctica Profesional del Entrenador Personal
                </span>
              </div>
            </div>

            <div className="h-0.5 w-full bg-primary mb-10 rounded-full" data-id="element-406" />

            <div className="flex flex-col items-center" data-id="element-407">
              <span className="text-gray-400 text-sm font-bold uppercase tracking-widest mb-2" data-id="element-408">
                VALOR TOTAL REAL
              </span>
              <span className="text-3xl md:text-4xl text-gray-500 line-through font-black mb-6 notranslate" translate="no" data-id="element-409">
                $49.975 ARS
              </span>

              <span className="text-white font-bold text-xl md:text-2xl mb-2" data-id="element-410">
                HOY PAGÁS SOLO
              </span>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-411">
                <span className="text-5xl md:text-7xl font-black text-primary font-heading notranslate" translate="no" data-id="element-412">
                  $19.990
                </span>
                <span className="text-2xl md:text-3xl font-bold text-primary notranslate" translate="no" data-id="element-413">
                  ARS
                </span>
              </div>

              <p className="text-gray-500 text-sm italic max-w-md" data-id="element-414">
                Precio promocional por tiempo limitado — incluye los 2 bonos en
                todas las opciones
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}